import { PlanSubscriptionDetails } from "@models/plan-subscription-details";

/** Seconds left for Companion UI, or null when talk time is unlimited (non-positive plan cap). */
export function companionRemainingTalkSeconds(
  subscription: PlanSubscriptionDetails,
): number | null {
  if (subscription.plan.limits.talkSeconds <= 0) {
    return null;
  }
  return subscription.remainingLimits.talkSeconds ?? 0;
}

export function isActiveTrial(subscription: PlanSubscriptionDetails): boolean {
  return (
    !subscription ||
    !!(
      subscription.isTrial &&
      subscription.expirationDate &&
      new Date(subscription.expirationDate).getTime() > Date.now()
    )
  );
}

export function isExpired(subscription: PlanSubscriptionDetails): boolean {
  return (
    !subscription ||
    !!(
      subscription.expirationDate &&
      new Date(subscription.expirationDate).getTime() <= Date.now()
    )
  );
}

export function isLimitReached(subscription: PlanSubscriptionDetails): boolean {
  return (
    !subscription ||
    !!(
      subscription.remainingLimits &&
      (isPhotosLimitReached(subscription) || isRemindersLimitReached(subscription) || isCallTimeLimitReached(subscription))
    )
  );
}

export function isPhotosLimitReached(subscription: PlanSubscriptionDetails): boolean {
  // Align with backend PlansService.checkUsage: limit 0 means unlimited (no enforcement).
  return (
    subscription.plan.limits.photos > 0 &&
    subscription.remainingLimits.photos != null &&
    subscription.remainingLimits.photos <= 0
  );
}

export function isRemindersLimitReached(subscription: PlanSubscriptionDetails): boolean {
  return (
    subscription.plan.limits.reminders > 0 &&
    subscription.remainingLimits.reminders != null &&
    subscription.remainingLimits.reminders <= 0
  );
}

export function isCallTimeLimitReached(subscription: PlanSubscriptionDetails): boolean {
  return (
    subscription.plan.limits.talkSeconds > 0 &&
    subscription.remainingLimits.talkSeconds != null &&
    subscription.remainingLimits.talkSeconds <= 0
  );
}
